import { primitives } from './primitives';

/*
 * The payment form renders identically in every theme mode by design: it is a white form
 * regardless of the page around it, so both palettes share this one block.
 * Token names follow the monetisation convention described in types.ts.
 */
export const payment = {
  background: primitives.white,
  backgroundSecondary: primitives.gray[100],
  primaryText: primitives.ink,
  secondaryText: primitives.gray[700],
  linkText: primitives.sky[300],
  tab: primitives.lavender[50],
  tabActive: primitives.lavender[100],
  tabBorder: primitives.lavender[200],
  tabActiveBorder: primitives.lavender[400],
  onTab: primitives.lavender[400],
  // Styles handed to the Solid card-form SDK (cross-origin iframe), not CSS of ours.
  submitButton: primitives.lime[500],
  submitButtonDisabled: primitives.slate[300],
  // PayPal's brand gold, fixed by PayPal's guidelines.
  paypal: primitives.amber[400],
  paypalHover: primitives.amber[500],
};
